module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('ul', {
    staticClass: "progress-bar",
    class: {
      mini: _vm.mini
    }
  }, [_vm._l((_vm.progressSteps), function(step) {
    return _c('li', [_c('router-link', {
      class: [step.type, {
        'completed': step.isCompleted,
        'active': step.isActive
      }],
      attrs: {
        "to": step.link
      }
    }, [_c('span', [_vm._v(_vm._s(step.precedence))])])], 1)
  }), _c('li', [_c('router-link', {
    staticClass: "done",
    class: {
      'active': _vm.isDoneStepActive
    },
    attrs: {
      "to": _vm.doneLink
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bec1302","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/elements/ProgressBar.vue
// module id = zVE9
// module chunks = 1